module.exports = __webpack_public_path__ + "img/ginny-miedo.76eb6392.svg";